<template>
    <div class="book_comment_item">
        <router-link tag="h3" class="title" v-if="item.title" :to="{name:'commentDetail',params:{commentPara:'product_id=' + item.product_id + '&main_product_id=' + item.main_product_id + '&product_category=' + item.category_path +'&comment_cust_id=' + item.customer_id + '&order_id=' + item.order_id + '&shop_id=' + item.shop_id + '&comment_type=' + commentType  + '&comment_id=' + item.comment_id }}">
        {{item.title}}
        </router-link>
        <div class="fabulous clearFix">
            <star :score="item.score" class="fl"></star>
            <div class="fabulous_hand fr clearFix">
                <good :good-num="item"></good>
                <div class="fabulous_hand_common fl">
                    <div class="repaly" ></div>
                    <router-link dd_name="评论回复按钮" :to="{name:'commentDetail',params:{commentPara:'product_id=' + item.product_id + '&main_product_id=' + item.main_product_id + '&product_category=' + item.category_path +'&comment_cust_id=' + item.customer_id + '&order_id=' + item.order_id + '&shop_id=' + item.shop_id  + '&fromReply=true' + '&comment_type=' + commentType + '&comment_id=' + item.comment_id }}" class="reply_text">{{item.total_reply_num == 0 ? '回复' : item.total_reply_num}}</router-link>
                </div>
            </div>
        </div>
        <router-link :to="{name:'commentDetail',params:{commentPara:'product_id=' + item.product_id + '&main_product_id=' + item.main_product_id + '&product_category=' + item.category_path +'&comment_cust_id=' + item.customer_id + '&order_id=' + item.order_id + '&shop_id=' + item.shop_id + '&comment_type=' + commentType  + '&comment_id=' + item.comment_id }}" class="comment_text">
               
            <div :class="this.commentType == 1 ? 'comment_maxline3' : 'comment_maxline'" class="comment_text_p" ref="comment_text_p"><top-wonder :comment="item"></top-wonder><span v-html="item.content"></span></div>
            <span :class="showClass">查看全部</span>
        </router-link>

        <a :href="item.product_url || 'javascript:;'" class="clearFix">
            <img class="fl" v-lazy="item.image_url" alt="">
            <div class="describe">
                <p class="omit">{{item.product_name || '暂无书名'}}</p>
                <div class="omit">{{item.author_name || '暂无作者信息'}}</div>
            </div>
        </a>
        <popup :pop-obj="errobj" v-if="errobj.type"></popup>
    </div>
</template>
<script>
import popup from './popup.vue'
import star from './star.vue'
import good from './good.vue'
import bad from './bad.vue'
import topWonder from './topWonder.vue'
export default {
    name: 'bookcomment',
    components: { popup, star, good, topWonder},
    props: ['content','hasShowMoreBtn', 'commentType'],
    data() {
        return {
            item: this.content,
            showAllBtn: false,
            showClass: {
                showAllBtn: true,
                showBtn: false
                
            },
            errobj: {
                type: '',
                errorMsg: ''            
            }
        }
    },
    mounted: function(){
        if(this.hasShowMoreBtn){
            if(this.$refs.comment_text_p.getBoundingClientRect().height > 9.5*parseFloat(document.documentElement.style.fontSize)){
                this.showClass.showBtn = true;
                this.textClass.comment_maxline = true;
            }
        }
    }
}
</script>
<style lang="stylus">
    @import '../common/stylus/omit.styl'
    .book_comment_item
        margin-bottom:1.25rem
        .title
            font-size: 0.8rem
            color:#505050
            margin-bottom:0.2rem
        .fabulous
            height:0.8rem
            .fabulous_hand
                .fabulous_hand_common
                    line-height:0.75rem
                    div
                        width:0.7rem
                        height:0.75rem
                        display:inline-block
                        margin-top:1px
                        vertical-align:middle
                    span
                        font-size:0.625rem
                        color:#969696
                        margin-left:-2px
                    .reply_text
                        font-size:0.625rem
                        color:#969696
                        margin:0
                        padding:0
                        margin-left:-2px
                        background:#fff
                        display:inline

                    .repaly
                        background:url('../assets/images/repaly.png') no-repeat
                        background-size:100% 100%
                        margin-left:0.5rem
        .comment_text
            width:100%
            background:#fff
            box-sizing:border-box
            overflow:hidden
            margin-top:0
            padding-left:0
            .comment_text_p
                font-size:0.65rem
                line-height:0.85rem
                word-break:break-all
                box-sizing:border-box
            .comment_maxline
                omit-line(10)
            .comment_maxline3
                omit-line(3)
            .showAllBtn
                display: none
                line-height: 1rem
                margin-top: .5rem
                font-size: .65rem
                color: rgb(255,129,97)
                text-decoration: underline
            .showBtn
                display: block
        a
            display:block
            background:#f5f5f5     
            padding:0.5rem
            img
                width:2.5rem
            .describe
                margin-left:3rem
                font-size:.65rem
                p
                    margin-top:0.25rem
                    margin-bottom:0.2rem
                    color:#505050
                div
                    color:#969696
    .book_comment_item:last-child
        margin-bottom:0
</style>



// WEBPACK FOOTER //
// bookcomment.vue?516ac56c